import Vue from 'vue'
import Router from 'vue-router'
import Homepage from './views/Homepage.vue'
import LoginForm from './components/forms/LoginForm.vue'
import RegisterForm from './components/forms/RegisterForm.vue'
import store from './store'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage,
      children: [
        {
          path: '/login',
          name: 'login',
          component: LoginForm
        },
        {
          path: '/register',
          name: 'register',
          component: RegisterForm
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/partialBatchesPlanning',
      name: 'partialBatchesPlanning',
      component: () => import('./views/PartialBatchesPlanning.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/planning',
      name: 'planning',
      component: () => import('./views/Planning.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/remainingDocuments',
      name: 'remainingDocuments',
      component: () => import('./views/RemainingDocuments.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/Users.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('./views/History.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('./views/Reports.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/oneProcess',
      name: 'oneProcess',
      component: () => import('./views/OneProcess.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
